import React, { useContext, useState, ToastAndroid, useEffect } from "react";
import { getStoreInvoicePrinter, getStoreTagPrinter, getUserData } from "../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../StoreMenu";

import qz from "qz-tray";
import ButtonLink from "../../ButtonLink";

const PackageTagView = () => {
  const { storeData, brandProfileData } = getUserData();

  let store = storeData;
  let brand = brandProfileData;

  const location = useLocation();
  const {
    customerOrdersData,
    orderPackageData,
  } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const data = {
    storeName: store.storeName,
    brandName: brand.name,
    fullAddress: store.address.fullAddress,
    mobileNumber: store.mobileNo,
    email: store.email,
    orderNo: customerOrdersData.orderNo,
    billNo: customerOrdersData.invoiceNo,
    date:
      new Date(customerOrdersData.createdDate)?.getDate() +
      "-" +
      parseInt(new Date(customerOrdersData.createdDate)?.getMonth() + 1) +
      "-" +
      new Date(customerOrdersData.createdDate)?.getFullYear(),
    deliveryOn:
      new Date(customerOrdersData.deliveryOn)?.getDate() +
      "-" +
      parseInt(new Date(customerOrdersData.deliveryOn)?.getMonth() + 1) +
      "-" +
      new Date(customerOrdersData.deliveryOn)?.getFullYear(),
    customerName: customerOrdersData.customerName,
    mobileNo: customerOrdersData.customerMobile,
    packageName: orderPackageData.packageDTO.name,
    serviceName: orderPackageData.packageDTO.appService,
    itemCount: orderPackageData.itemCount,
    countGram: orderPackageData.countGram,
    serviceUnit: orderPackageData.packageDTO.serviceUnit,
    totalPrice: orderPackageData.totalPrice
  };

  const [isConnected, setIsConnected] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

   const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
    const fetchSelectedInvoicePrinter = async () => {
      try {
        const selectedInvoicePrinterData = await getStoreInvoicePrinter();
        setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
      } catch {
        setInvoicePrinterValue("");
      }
    };

   const [tagPrinterValue, setTagPrinterValue] = useState("");
  
    const fetchSelectedTagPrinter = async () => {
      try {
        const selectedTagPrinterData = await getStoreTagPrinter();
        setTagPrinterValue(selectedTagPrinterData?.tagPrinter || "");
      } catch {
        setTagPrinterValue("");
      }
    };

  useEffect(() => {
    if(!isConnected) 
      {
        connectToQZ();
      }

    fetchSelectedTagPrinter()
    fetchSelectedInvoicePrinter()
  }, [])
  
  const printTagHTML = async () => {
    try {
      // const printer = await qz.printers.find("POS80 Printer"); // Adjust to your printer's actual name
      const printer = await qz.printers.find(tagPrinterValue);
      // const printer = await qz.printers.find(invoicePrinterValue);
     const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        // size: { width: 2 },
        units: "in",
        density: "300",
        colorType: "grayscale",
      });

      const htmlContent = `
      <html>
        <body style="font-size: 20px; font-family: sans-serif;">
          <div style="text-align: center;">
            <p style="font-size: 12px; font-weight: bold; margin: 0;">${data.storeName}</p>
            <p style="font-size: 12px; font-weight: bold; margin: 0;">BD: ${data.date}</p>
            <p style="font-size: 16px; font-weight: bold; margin: 0;">DD: ${data.deliveryOn}</p>
            <p style="font-size: 16px; font-weight: bold; margin: 0;">Bill No.: ${data.billNo}</p>
            <p style="font-size: 12px; font-weight: bold; margin: 0;">
              ${data.customerName}
            </p>

            <p style="font-size: 12px; font-weight: bold; margin: 0;">
              ${data.packageName}
            </p>

            <p style="font-size: 16px; font-weight: bold; margin: 0;">
              ${data.serviceName}
            </p>

            <p style="font-size: 16px; font-weight: bold; margin: 0;">
              ${data.itemCount + data.countGram} ${data.serviceUnit === "Qty" ? "Piece" : data.serviceUnit}
            </p>

            <hr style="border-top: 1px dashed #000;"/>
          </div>
        </body>
      </html>
    `;

      await qz.print(config, [
        { type: "html", format: "plain", data: htmlContent },
      ]);
      // alert("HTML receipt sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print receipt");
    }
  };


  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate(-1)
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Package Tag
              </p>
            </div>
            <div className="flex">
              <div
                className="mx-4 cursor-pointer"
                onClick={printTagHTML}
              >
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex justify-content-between mt-2">
        <div></div>
        <div className="w-2 ">
          <div className="flex  justify-content-center flex-column print-section">
            <p className="text-xl font-medium text-center">
              {data.storeName}
            </p>
            <p className="text-xl font-medium text-center">
              BD : {data.date}
            </p>

            <p className="text-2xl font-medium text-center">
              DD : {data.deliveryOn}
            </p>

            <p className="text-2xl font-medium text-center">
              Bill No. : {data.billNo}
            </p>

            <p className="text-xl font-medium text-center">
              {data.customerName}
            </p>

            <p className="text-xl font-medium text-center">
              {data.packageName}
            </p>

            <p className="text-2xl font-medium text-center">
              {data.serviceName}
            </p>

            <p className="text-2xl font-medium text-center">
              {data.itemCount + data.countGram} {data.serviceUnit === "Qty" ? "Piece" : data.serviceUnit}
            </p>
           
          </div>
        </div>

        <div
          className="mr-4 mt-4 cursor-pointer"
          onClick={() => window.print()}
        >
          <img
            src={"Icons/printer.png"}
            style={{
              width: 65,
            }}
          />
        </div>
      </div>
      {/* Menu component */}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
                       @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PackageTagView;
